import React from 'react'
import { connectStateResults } from 'react-instantsearch/connectors'
import { Pagination } from 'react-instantsearch/dom'
import './algolia-pagination-override.css'
import { connectConfig } from '../config'

export const SearchPagination = ({ searchResults, config: { paginationPadding } }) => {
  return searchResults && searchResults.nbPages > 1
    ? <div className='search-pagination'>
      <Pagination
        showLast
        padding={paginationPadding}
        translations={{
          first: 'First',
          last: 'Last'
        }}
      />
    </div>
    : <p />
}
export default connectStateResults(connectConfig(SearchPagination))
